require('../style/utilities/_config.scss');
require('../style/utilities/_mixins.scss');
require('../style/layout/_extends.scss');
require('../style/utilities/_functions.scss');
require('../style/base/normalize.scss');
require('../style/base/base.scss');
require('../style/type.scss');
require('../style/parental.scss');
require('../style/player.scss');

import {ConfigurationBuilder} from './configuration-builder';
import {PlayerWrapper} from './player-wrapper';
import {CLIENT_ERRORS, DEFAULT_ERROR, ErrorHandler} from 'starzplayer';

// Run the player
try {
    const playerWrapper = new PlayerWrapper();
    const starzplayerConfiguration = new ConfigurationBuilder(decodeURIComponent(window.location.href))
        .build()
        .getConfiguration(); // FIXME Isn't this call not-needed? build function already returns the object

    playerWrapper.play(starzplayerConfiguration);
}
catch (e) {
    if (e.message !== 'StarzPlayerException') {
        console.error(e);
        ErrorHandler.throwError(DEFAULT_ERROR, {
            reason: 'An uncaught error happened.',
            error: e
        });
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/starzweb-player.js